'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Environment = require('./environment');
var SimpleLogger = require('./simple-logger');

// The Environments class knows how to get the configuration for each of demo, QA
// and live.
//
// It is the starting point for use of these resources.  However, it is not meant
// to be accessed directly.  The global function environment(name) should be used
// to get access to a given environment.

var Environments = function () {
    function Environments() {
        _classCallCheck(this, Environments);

        this.hosts = {
            local: '//localhost',
            localhost: '//localhost',
            demo: '//demo.3plearning.com',
            qa: '//config-qa.3plearning.com',
            live: '//config.3plearning.com'
        };

        this.callProxy = undefined;
        this.chatty = false;
        this.log = new SimpleLogger();
    }

    _createClass(Environments, [{
        key: 'withName',
        value: function withName(_ref) {
            var name = _ref.name,
                application = _ref.application,
                configPort = _ref.configPort,
                xmlHttpRequest = _ref.xmlHttpRequest,
                config = _ref.config;

            var host = this.hosts[name];

            if (host === undefined) {
                this.log.debug('"' + name + '" is not a predefined environment name; hopefully it\'s the address of a server.');

                if (/^http/.test(name)) {
                    host = name;
                } else {
                    host = 'http://' + name;
                }
            }

            var environment = environments[name];

            if (environment === undefined) {
                environment = environments[name] = new Environment({ name: name, host: host, application: application, configPort: configPort, xmlHttpRequest: xmlHttpRequest, config: config });
            }

            return environment;
        }
    }]);

    return Environments;
}();

var environments = new Environments();

// A convenience function for accessing the individual environments

function environment(_ref2) {
    var name = _ref2.name,
        application = _ref2.application,
        configPort = _ref2.configPort,
        xmlHttpRequest = _ref2.xmlHttpRequest,
        config = _ref2.config;

    var log = new SimpleLogger();

    if (name === undefined) {
        var message = 'Environments.environment() - Please provide the name of the environment you want\n' + 'as the first argument.  Possible values: "demo", "qa", "live".';

        log.scream(message);

        throw message;
    }

    if (application === undefined) {
        var _message = 'Environments.environment() - Please provide the application name \n' + 'as the second argument.';

        log.scream(_message);

        throw _message;
    }

    // The 'localhost' environment is used by back-end developers
    // when they want to hit the services running on their own
    // machines.
    //
    // In this case, they can specify a 'port' query parameter to
    // say where their configuration service lives. If they don't,
    // we want to default to 8080.

    if (name === 'localhost' && configPort === undefined) {
        configPort = 8080;
    }

    return environments.withName({ name: name, application: application, configPort: configPort, xmlHttpRequest: xmlHttpRequest, config: config });
}

function $environmentWithConfiguration(configValues) {
    // We want to create an Environment whose configuration
    // contains the values that were passed in.

    return new Environment(name, configValues);
}

module.exports = environment;


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/resource/lib/environments.js
// module id = P7H2
// module chunks = 0